<template>
  <div data-component-group="threads-form" data-component="duplicates">
    <v-list lines="two" class="duplicates-list">
      <template v-for="(thread) in duplicates" :key="thread.id">
        <v-list-item
          class="duplicate-item"
          :title="`Duplicate deal - ${thread.title}`"
        >
          <div class="duplicate-thread">
            <span class="duplicate-icon">
              <v-icon>warning</v-icon>
            </span>

            <span class="duplicate-date">
              {{ getDuplicateDate(thread) }}
            </span>

            <span class="duplicate-price">
              {{ getDuplicatePrice(thread) }}
            </span>

            <span class="duplicate-link">
              <v-btn :to="getDuplicateLink(thread)" variant="text" size="small">
                <v-icon>link</v-icon>
                {{ 'Link' }}
              </v-btn>
            </span>
          </div>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
// TODO: Translate component

  export default {
    props: {
      duplicates: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        archivedStatusIds: [],
      };
    },
    created() {
      this.$store
        .dispatch('threads/getFilterStatuses', { archived: 1 })
        .then((statuses) => {
          this.archivedStatusIds = statuses.map(({ id }) => id);
        });
    },
    methods: {
      getDuplicateDate(thread) {
        return this.$dayjs(thread.created_at).fromNow();
      },
      getDuplicatePrice(thread) {
        return `${thread.price} ${thread.country.currency.symbol}`;
      },
      getDuplicateLink(thread) {
        return this.archivedStatusIds.includes(thread.status?.id)
          ? `/threads/archived/${thread.id}`
          : `/threads/${thread.id}`;
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='threads-form'] {
  &[data-component='duplicates'] {
    .duplicates-list {
      padding: 0;
      margin: 0;
      background-color: transparent;

      @media (max-width: map.get($breakpoints, sm)) {
        margin: 0 -24px -14px -34px;
      }
    }

    .v-list-item {
      height: auto;
      min-height: 30px;
    }

    .v-list-item__content {
      padding: $spacing-xs 0;
    }

    .duplicate-item {
      color: map.get($colors, shades, 'white');
      background-color: map.get($colors, primary);
      border-bottom: 2px solid map.get($colors, grey, darken-4);
      border-radius: $border-radius;
      margin: 0 0 4px 0;

      &:last-child {
        border: none;
        margin: 0;
      }

      .duplicate-thread {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: map.get($colors, shades, 'white');
      }

      .duplicate-icon {
        .v-icon {
          color: map.get($colors, shades, 'white');
          margin: 0 20px 0 0;
        }
      }

      .duplicate-price,
      .duplicate-title,
      .duplicate-link {
        font-size: $text-size-sm;

        &:before {
          content: '|';
          color: map.get($colors, grey, lighten-3);
          margin: 0 16px;
        }
      }

      .duplicate-title {
        max-width: 180px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        @media (max-width: map.get($breakpoints, xs)) {
          &:before {
            display: none;
          }
        }
      }

      .duplicate-price {
        @media (max-width: map.get($breakpoints, sm)) {
          display: none;
        }
      }

      .duplicate-date {
        @media (max-width: map.get($breakpoints, xs)) {
          display: none;
        }
      }

      .duplicate-link {
        .v-btn {
          margin: 0 0 0 -8px;
          color: map.get($colors, shades, 'white');

          .v-icon {
            font-size: $text-size-xl;
            margin: 0 6px 0 0;
          }
        }
      }
    }
  }
}
</style>
